export const stripDollarSign = value => value.replace(/^[\$]+/, '');
